import { Component } from 'react';
import PropTypes from 'prop-types';
import VSTUI from '../utils';

class VstComponent extends Component {

  constructor() {
    super();
    this._vstComponentUIUpdate = this._vstComponentUIUpdate.bind(this);
    this.state = {};
    this._oldComponentWillUnmount = this.componentWillUnmount;
    this.parentWillUnmount = this.parentWillUnmount.bind(this);
    this.componentWillUnmount = (e) => {
      this.parentWillUnmount(e);
      this._oldComponentWillUnmount(e);
    };
    this._oldComponentDidMount = this.componentDidMount;
    this.parentDidMount = this.parentDidMount.bind(this);
    this.componentDidMount = (e) => {
      this.parentDidMount(e);
      this._oldComponentDidMount(e);
    };
  }

  componentDidMount() {}
  componentWillUnmount() {}

  _returnTheme(index) {
    if (this.props.accent) {
      return VSTUI.theme.getAccent(index);
    } else if (this.props.primary) {
      return VSTUI.theme.getPrimary(index);
    }
    return VSTUI.theme.getPrimary(index);
  }

  _theme(index) {
    if (this.props.theme) {
      return VSTUI.colors[this.props.theme][index];
    } else if (this.props.themeMap) {
      const keys = Object.keys(this.props.themeMap);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        const key = keys[i];
        if ((this.props.primary && VSTUI.theme.primaryKey === key) ||
            (this.props.accent && VSTUI.theme.accentKey === key)) {
          return VSTUI.colors[this.props.themeMap[key]][index];
        }
      }
    }
    return this._returnTheme(index);
  }

  _vstComponentUIUpdate() {
    this.forceUpdate();
  }

  parentDidMount() {
    document.addEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
  }

  parentWillUnmount() {
    document.removeEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
  }

}

VstComponent.propTypes = {
  primary: PropTypes.bool,
  accent: PropTypes.bool,
  theme: PropTypes.string,
  themeMap: PropTypes.object
};

VstComponent.defaultProps = {
  primary: true,
  accent: undefined,
  theme: undefined,
  themeMap: undefined
};

export default VstComponent;
